<template>
    <el-container>
        <el-header height="100px">
            <el-row type="flex" align="middle">
                <el-col :span="8" type="flex" align="center">
                    <el-image src="http://www.woer.com/dist/images/logo.png"/>
                </el-col>
                <!--<el-col :span="2" type="flex" align="center">
                    首页
                </el-col>
                <el-col :span="2" type="flex" align="center">
                    社会招聘
                </el-col>
                <el-col :span="2" type="flex" align="center">
                    校园招聘
                </el-col>
                <el-col :span="2" type="flex" align="center">
                    关于我们
                </el-col>-->
                <el-col :span="8" type="flex" align="center">
                    <el-menu :default-active="menuActive" class="el-menu-top" mode="horizontal" @select="handleSelect">
                        <el-menu-item index="1"><a href="http://www.woer.com/about/companyculture/Copy/Copy3261/" target="_blank">首页</a></el-menu-item>
                        <el-menu-item index="2"><router-link :to="{path :'/recruit/list',query:{workouttype:'社会招聘'}}">社会招聘</router-link></el-menu-item>
                        <el-menu-item index="3">
                            <router-link :to="{path :'/recruit/list',query:{workouttype:'校园招聘'}}">校园招聘</router-link>
                        </el-menu-item>
                        <el-menu-item index="4"><a href="https://space.bilibili.com/46466717" target="_blank">校招进程</a></el-menu-item>
                    </el-menu>
                </el-col>
                <el-col v-show="isShow" :span="8" type="flex" align="center">
                    <router-link to="/login">登录</router-link>
                    /
                    <router-link to="/register">注册</router-link>
                </el-col>
                <el-col v-show="!isShow" :span="8" type="flex" align="center">
                    <router-link to="/">个人中心</router-link>
                </el-col>
            </el-row>
        </el-header>

        <el-main style="padding: 0;">
            <router-view/>
        </el-main>
        <el-footer>Copyright © 2022 深圳市沃尔核材股份有限公司 粤ICP备10028260号 咨询热线 0755-28299123</el-footer>
    </el-container>
</template>

<script>
    import * as c from '@/util/config'
    import * as u from '@/util/util'

    export default {
        name: "zp_base",
        data(){
            return {
                isShow: true,
                //用户信息
                userInfo: u.getSession(c.sessionKey.USER_INFO),
                menuActive: '3',
            }
        },
        created() {
            this.isShow = this.userInfo ? false : true;
            if(this.$route.query.workouttype == '社会招聘'){
                this.menuActive = '2';
            }
        },
        methods: {
            handleSelect() {

            }
        }
    }
</script>
<style>
    .el-menu-top {
        border-bottom: solid 0px !important;
    }

    .el-menu-top > .el-menu-item {
        color: #000000;
        font-size: 20px;
    }

    .el-menu-item a {

        text-decoration: none; /* 去除默认的下划线 */
        color: #000; /* 去除默认的颜色和点击后变化的颜色 */
    }

    .el-footer {
        background-color: #B3C0D1;
        color: #333;
        text-align: center;
        line-height: 60px;
    }

    .el-main {
        background-color: #E9EEF3;
        color: #333;
        text-align: center;
    }

    .el-header {
        background-color: #FFFFFF;;
        color: #333;
        line-height: 60px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }

    .el-image {
        margin-top: 20px;
        margin-left: 20px;
    }

</style>
